import React from 'react';
import MaterialsSection from 'components/quote_builder_widget/shared/MaterialsSection';

const CorrugatedCardboardMaterialsSection = ({ onMaterialsChange }) => {
  return (
    <MaterialsSection
      materialType="corrugated_cardboard_material"
      translationPrefix="corrugated_cardboard"
      onMaterialsChange={onMaterialsChange}
    />
  );
};

export default CorrugatedCardboardMaterialsSection;
